import { render } from "./Header.vue?vue&type=template&id=a5c78ce8&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/assets/css/Header.scss?vue&type=style&index=0&id=a5c78ce8&lang=scss&scoped=true"
import "@/assets/css/HelpModal.scss?vue&type=style&index=1&id=a5c78ce8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c78ce8"]])

export default __exports__